import { Component, Inject } from '@angular/core';
import { ApplicationsService } from '../applications.service';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { Application } from '../application.model';
import { UIDialogData } from 'app/ui/dialog/dialog-injector';
import { DialogEventEnum } from 'app/ui/dialog/dialog-event.enum';

@Component({
  selector: 'delete-application',
  templateUrl: 'delete-application.component.html',
  styleUrls: ['delete-application.component.scss']
})
export class DeleteApplicationComponent {
  isLoading = false;

  constructor(
    @Inject(UIDialogData)
    public application: Application,
    private applicationsServiice: ApplicationsService,
    private dialogService: UIDialogService
  ) {}

  async delete() {
    this.isLoading = true;
    try {
      await this.applicationsServiice
        .deleteApplication(this.application.id)
        .toPromise();
      this.dialogService.close(DialogEventEnum.delete);
    } catch (error) {
      console.error(error);
      this.isLoading = false;
    }
  }

  cancel() {
    this.dialogService.close();
  }
}
